import { useParams } from 'react-router-dom';

import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';

import PaymentHistoryForm from '../../modules/payable/history/components/PaymentHistoryForm';

const PaymentHistoryPage = () => {
  const { payableId } = useParams();

  const parsedPayableId = payableId ? Number(payableId) : undefined;

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <PaymentHistoryForm key={parsedPayableId} payableId={parsedPayableId} />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default PaymentHistoryPage;
